export const APPLICATION_ID_PARAMETER = "applicationId";
export const PREFILLED_PARAMETER = "prefilled";
export const PROPERTY_ID_PARAMETER = "property-id";
export const GROUP_ID_PARAMETER = "group-id";
export const CONTACT_ID_PARAMETER = "contact-id";
export const EQUITY_PARAMETER = "equity";
export const INCOME_PARAMETER = "income";
export const PURCHASE_PRICE_PARAMETER = "purchase-price";
export const CITY_PARAMETER = "city";
export const STREET_PARAMETER = "street";
export const POSTAL_CODE_PARAMETER = "postal-code";
export const VIEWING_PARAMETER = "viewing";
export const EMAIL_PARAMETER = "email";
export const LEAD_ID_PARAMETER = "leadId";
export const PROJECT_ID_PARAMETER = "projectId";
export const DEAL_ID_PARAMETER = "dealId";
export const FIRST_NAME_PARAMETER = "first_name";
export const LAST_NAME_PARAMETER = "last_name";
export const PHONE_PARAMETER = "phone";
export const SKIP_QUALIFICATION_PARAMETER = "skip";
